import { createSlice } from '@reduxjs/toolkit'

export interface UserSliceStateType {
  isAuthLoading: boolean
  authHeader: string | null
  userOverride: string | null
  instantSaveQuota: number | undefined
}

const initialState: UserSliceStateType = {
  isAuthLoading: true,
  authHeader: null,
  userOverride: null,
  instantSaveQuota: undefined,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAuthHeader: (state, action) => {
      state.isAuthLoading = false
      state.authHeader = action.payload
    },
    clearAuthHeader: (state) => {
      state.authHeader = null
    },
    setInstantSaveQuota: (state, action) => {
      state.instantSaveQuota = action.payload
    },
    decInstantSaveQuota: (state, _action) => {
      if (state.instantSaveQuota) {
        state.instantSaveQuota -= 1
      }
    },
    incInstantSaveQuota: (state, _action) => {
      if (state.instantSaveQuota) {
        state.instantSaveQuota += 1
      }
    },
    setUserOverride: (state, action) => {
      state.userOverride = action.payload
    },
  },
})

export const {
  setAuthHeader,
  clearAuthHeader,
  setInstantSaveQuota,
  decInstantSaveQuota,
  incInstantSaveQuota,
  setUserOverride,
} = userSlice.actions

export default userSlice.reducer
